<template>
    <Section width="sm" class="newsletter-signup">
        <div 
            v-if="!submitted" 
            class="container flex flex-y-start text-left" 
            :class="{'centered text-center': alignCenter}"
        >
            <span v-if="$validateText(header)" class="rich-text margin-bottom-2" v-html="header" />
            <div class="rich-text margin-bottom-2" :class="{'centered': alignCenter}" v-html="text" />
            <div class="padding-y-4 flex width-full input-container" :class="{'flex-x-start': !alignCenter}">
                <div class="input-wrapper">
                    <input 
                        v-model="email"
                        type="text"
                        :class="['br-5 margin-0', {invalid: emailError}]"
                        :placeholder="emailPlaceholder"
                        @input="clearError"
                    >
                    <div v-if="emailError" class="invalid-message red">
                        {{ $translate('guide_email_error', 'Fyll i en giltig email') }}
                    </div>
                </div>
                <a class="btn btn-md btn-green" @click="submit">{{ buttonText }}</a>
            </div>
            <div class="terms rich-text" :class="{'centered': alignCenter}" v-html="terms" />
        </div>
        <div v-else class="section-width-sm">
            <div class="rich-text" :class="{'text-center': alignCenter}" v-html="successText" />
        </div>
    </Section>
</template>

<script>
import NewsletterSignupMixin from '@/components/newsletter-signup/Mixin.js';

export default {
    mixins: [NewsletterSignupMixin],
    props: {
        data: {
            type: Object,
            required: true,
        }
    },
    computed: {
        settings() {
            return this.$store.state.settings;
        },
        header() {
            return this.$validateText(this.data.primary.header) ? 
                this.$prismic.asHtml(this.data.primary.header) : 
                `<h2>${this.settings.newsletter_signup_header}</h2>`;
        },
        text() {
            return this.$validateText(this.data.primary.text) ? 
                this.$prismic.asHtml(this.data.primary.text) : 
                `<p>${this.settings.newsletter_signup_p}</p>`;
        },
        buttonText() {
            return this.$validateText(this.data.primary.button_text) ? 
                this.data.primary.button_text : 
                this.settings.newsletter_signup_button_text;
        },
        terms() {
            return this.$validateText(this.data.primary.terms) ? 
                this.$prismic.asHtml(this.data.primary.terms) : 
                `<p>${this.settings.newsletter_signup_terms}</p>`;
        },
        successText() {
            return this.$validateText(this.data.primary.success_text) ? 
                this.$prismic.asHtml(this.data.primary.success_text) : 
                `<h2>${this.settings.newsletter_signup_success_text}</h2>`;
        },
        emailPlaceholder() {
            return this.settings.newsletter_signup_email_placeholder;
        },
        alignCenter() {
            return this.data.primary.align_content === 'center';
        }
    },
    methods: {
        clearError() {
            this.emailError = false;
        }
    }
};
</script>